import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { isLoading, RenderModule } from 'holocron';
import { useIntl } from 'react-intl';
import { clsx } from 'clsx';
import { ProgressCircular } from '@americanexpress/dls-react';
import themeContext from '../../context/themeContext';
import { GUESTBOOK_TAB, TAB_TO_MODULE_NAME } from '../../constants/linesOfBusinessConstants';
import getTabSelected from '../../selectors/tabSelector';

const LineOfBusinessTab = ({
  lineOfBusiness, shouldDisplayHeading, isMosaicDesign,
}) => {
  const moduleName = TAB_TO_MODULE_NAME[lineOfBusiness];
  const isModuleLoading = useSelector(isLoading(moduleName));
  const theme = useContext(themeContext);
  const { formatMessage } = useIntl();
  const selectedLob = useSelector(getTabSelected);

  if (isModuleLoading) {
    return (
      <div className="text-align-center pad-3">
        <ProgressCircular size="lg" />
      </div>
    );
  }

  return (
    <div
      id={`${lineOfBusiness}-body`}
      key={`${lineOfBusiness}-body`}
      data-testid={`${lineOfBusiness}-body`}
      role="tabpanel"
      aria-labelledby={shouldDisplayHeading ? 'search-body-title' : `${lineOfBusiness}-tab`}
    >
      {(lineOfBusiness === selectedLob) && (
        <>
          {shouldDisplayHeading && (
            <div
              id="search-body-title"
              className={clsx('pad-l pad-1-t body-bold', theme !== 'blue' && 'dls-white-bg')}
            >
              {formatMessage({ id: lineOfBusiness })}
            </div>
          )}
          <RenderModule
            moduleName={moduleName}
            props={{
              theme,
              isMosaicDesign,
              hasPartnerInfoBanner: lineOfBusiness === GUESTBOOK_TAB,
            }}
          />
        </>
      )}
    </div>
  );
};

LineOfBusinessTab.propTypes = {
  lineOfBusiness: PropTypes.string.isRequired,
  shouldDisplayHeading: PropTypes.bool,
  isMosaicDesign: PropTypes.bool,
};

export default LineOfBusinessTab;
